import React, { useEffect, useState } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

import { doService } from "../../../services/ServiceHelper";
import { getScoreCategories } from "../../../services/ScoreService";

function ScoreCategorySelector({ school, jwt, onChange }) {
  const [_scoreCategories, setScoreCategories] = useState([]);

  useEffect(() => {
    initScoreCategories();
  }, []);

  const initScoreCategories = () => {
    doService(getScoreCategories(school, jwt), (results) => {
      const entries = [];
      for (const entry of results.data) {
        entries.push({
          label: entry.name,
          value: entry.id,
        });

      }
      setScoreCategories(entries);
    });
  };

  const handleChangeScoreCategories = (value) => {
   if (onChange) {
      onChange(value);
    }
  };

  return (
    <>
      <InputLabel>Select Score Categories *</InputLabel>
      <Select
        options={_scoreCategories}
        onChange={handleChangeScoreCategories}
        isMulti={true}
      />
    </>
  );
}

export default ScoreCategorySelector;
